
import styles from "./ThirdScreen.module.css";
import { useEffect } from "react";
import ScrollReveal from "scrollreveal";
import Button from "../components/button/Button";

const ThirdScreen = () => {
  useEffect(() => {
    ScrollReveal().reveal(`.${styles.title}`, {
      duration: 1000,
      distance: "30px",
      origin: "top",
      easing: "ease-out",
      reset: false,
      viewFactor: 0.2,
      interval: 300,
      delay: 200,
      scale: 1,
    });
    ScrollReveal().reveal(`.${styles.subtitle}`, {
      duration: 1000,
      distance: "30px",
      origin: "top",
      easing: "ease-out",
      reset: false,
      viewFactor: 0.2,
      interval: 300,
      delay: 400,
      scale: 1,
    });
    ScrollReveal().reveal(`.${styles.section}`, {
      duration: 1000,
      distance: "30px",
      origin: "right",
      easing: "ease-in-out",
      reset: false,
      viewFactor: 0.2,
      interval: 300,
      delay: 200,
      scale: 1,
    });
    ScrollReveal().reveal(`.${styles.stepHeader}`, {
      duration: 1000,
      distance: "30px",
      origin: "top",
      easing: "ease-in-out",
      reset: false,
      viewFactor: 0.2,
      interval: 300,
      delay: 200,
      scale: 1,
    });
    ScrollReveal().reveal(`.${styles.numberText}`, {
      duration: 1200,
      distance: "20px",
      origin: "left",
      easing: "ease-out",
      reset: false,
      viewFactor: 0.2,
      interval: 300,
      delay: 100,
      scale: 0.9,
      opacity: 0,
    });
  }, []);

  return (
    <>
      <div className={styles.bigWrapper}>
        <div className={styles.step} itemScope itemType="https://schema.org/Service">
          <div className={styles.icons}>
            <div className={styles.numberWrapper}>
              <div className={`${styles.numberText} ${styles.number1}`}>01</div>
            </div>
          </div>
          <div className={styles.text}>
            <div className={styles.stepHeader} itemProp="name">תכנון מדויק וברור</div>
            <div className={styles.section} itemProp="description">
              מהמפגש הראשון מוצג בפניכם תהליך עבודה מסודר. אתם יודעים מה צפוי, מה העלויות, ומה התוצאה שתתקבל. ללא חוסר בהירות וללא ניחושים.
            </div>
          </div>
        </div>

        <div className={styles.step} itemScope itemType="https://schema.org/Product">
          <div className={styles.text}>
            <div className={styles.stepHeader} itemProp="name">בחירות נכונות ובטוחות</div>
            <div className={styles.section} itemProp="description">
              תוך זמן קצר אתם תקבלו הדמיות שמאפשרות לכם לראות את התמונה השלמה מראש. את הצבעים, הריהוט, המיקומים של כל דבר.. וכל זה כדי למנוע טעויות מיותרות וחיסכון בהוצאות.
            </div>
          </div>
          <div className={styles.icons}>
            <div className={styles.numberWrapper}>
              <div className={`${styles.numberText} ${styles.number2}`}>02</div>
            </div>
          </div>
        </div>

        <div className={styles.step} itemScope itemType="https://schema.org/Organization">
          <div className={styles.icons}>
            <div className={styles.numberWrapper}>
              <div className={`${styles.numberText} ${styles.number3}`}>03</div>
            </div>
          </div>
          <div className={styles.text}>
            <div className={styles.stepHeader} itemProp="name">חיסכון בזמן ובמאמץ</div>
            <div className={styles.section} itemProp="description">
              אין צורך להתרוצץ בין ספקים וחנויות. אני מרכזת את כל האפשרויות המתאימות עבורכם ומובילה אתכם להחלטות מדויקות ויעילות.
            </div>
          </div>
        </div>

        <div className={styles.step} itemScope itemType="https://schema.org/Service">
          <div className={styles.text}>
            <div className={styles.stepHeader} itemProp="name">שליטה מלאה בתקציב</div>
            <div className={styles.section} itemProp="description">
              כל שלב מתוכנן מראש בליווי נתונים ברורים. אתם יודעים בדיוק על מה מושקע כל סכום ושומרים על גבולות התקציב ללא הפתעות וולא הוצאות מיותרות.
            </div>
          </div>
          <div className={styles.icons}>
            <div className={styles.numberWrapper}>
              <div className={`${styles.numberText} ${styles.number4}`}>04</div>
            </div>
          </div>
        </div>

        <div className={styles.step} itemScope itemType="https://schema.org/Organization">
          <div className={styles.icons}>
            <div className={styles.numberWrapper}>
              <div className={`${styles.numberText} ${styles.number5}`}>05</div>
            </div>
          </div>
          <div className={styles.text}>
            <div className={styles.stepHeader} itemProp="name">ליווי אישי עד סיום הפרויקט</div>
            <div className={styles.section} itemProp="description">
              אני זמינה לאורך כל הדרך, מתאמת מול בעלי המקצוע, מפקחת על הביצוע, ודואגת לכל פרט עד קבלת המפתח. אתם חווים תהליך רגוע ובטוח.
            </div>
          </div>
        </div>
      </div>

      <div className={styles.description}>
        והכי חשוב - אני כאן להקשיב לכם,לצרכים שלכם ולהוביל אתכם לדירה שתמיד חלמתם עליה
      </div>

      <Button text="טלי, נשמח לשוחח על הדירה שלנו" />
    </>
  );
};

export default ThirdScreen;
